module.exports = __webpack_public_path__ + "static/media/asma-nav.0914cca3.png";